
const DATASCIENCE_LOGOS = [
    "pandas",
    "numpy", 
    "python", 
    "tensorflow", 
    "sklearn", 
    "matplotlib", 
    "seaborn", 
    "scrapy"
]

const AIML_LOGOS = [
    "tensorflow", 
    "sklearn", 
    "numpy", 
    "pandas",
    "matplotlib", 
    "python", 

]

const FRONTEND_LOGOS = [
    "react", 
    "html", 
    "css", 
    "javascript", 
    "sass", 
    "nodejs",
    "express"
]

const GENERAL_LOGOS = [
    "docker", 
    "vscode", 
    "git",
    "raspberrypi"
]

const LOGOS_ARRAY = [


    DATASCIENCE_LOGOS, 
    AIML_LOGOS, 
    FRONTEND_LOGOS, 
    GENERAL_LOGOS
]

export default LOGOS_ARRAY